import axios, { AxiosError, type AxiosResponse } from 'axios';
import { NEXT_PUBLIC_KENALL_PUBLIC_KEY } from '~/lib/config';

type KenallAddressResponse = {
  version: string;
  data: KenallAddressResponseData[];
};

type KenallAddressResponseData = {
  jisx0402: string;
  old_code: string;
  postal_code: string;
  prefecture_kana: string;
  city_kana: string;
  town_kana: string;
  town_kana_raw: string;
  prefecture: string;
  city: string;
  town: string;
  koaza: string;
  kyoto_street: string;
  building: string;
  floor: string;
  town_partial: boolean;
  town_addressed_koaza: boolean;
  town_chome: boolean;
  town_multi: boolean;
  town_raw: string;
  corporation: any;
};

export const fetchAddressByZipcode = async (
  zip_code: string
): Promise<KenallAddressResponse & { status: number }> => {
  try {
    const address: AxiosResponse<KenallAddressResponse> = await axios.get(
      `https://api.kenall.jp/v1/postalcode/${zip_code}`,
      {
        headers: {
          Authorization: `Token ${NEXT_PUBLIC_KENALL_PUBLIC_KEY}`,
        },
        params: {
          version: '2021-02-26',
        },
      }
    );

    return {
      ...address.data,
      status: address.status,
    };
  } catch (error) {
    if (isAxiosError(error)) {
      return { status: error.response?.status ?? 500, data: [], version: '' };
    }
    return { status: 500, data: [], version: '' };
  }
};

const isAxiosError = (error: any): error is AxiosError => {
  return !!error.isAxiosError;
};
